/**
 * Permission Dialog - Pre-recording authentication and consent
 */

import { useState } from 'react';
import './PermissionDialog.css';

interface PermissionDialogProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export function PermissionDialog({ isOpen, onAccept, onDecline }: PermissionDialogProps) {
  const [agreed, setAgreed] = useState(false);

  if (!isOpen) return null;

  const handleAccept = () => {
    if (agreed) {
      onAccept();
    }
  };

  return (
    <div className="permission-dialog-overlay">
      <div className="permission-dialog">
        <div className="permission-header">
          <h2 className="permission-title">🎤 Ready to Record?</h2>
        </div>

        <div className="permission-body">
          <p className="permission-description">
            Before you start recording, please review and agree to the following:
          </p>

          <div className="permission-details">
            <div className="permission-item">
              <span className="permission-icon">🔒</span>
              <div>
                <h3>Authentication Required</h3>
                <p>We'll authenticate with our transcription service to process your audio.</p>
              </div>
            </div>

            <div className="permission-item">
              <span className="permission-icon">🎙️</span>
              <div>
                <h3>Microphone Access</h3>
                <p>Your browser will request permission to access your microphone.</p>
              </div>
            </div>

            <div className="permission-item">
              <span className="permission-icon">☁️</span>
              <div>
                <h3>Audio Processing</h3>
                <p>
                  Your audio is sent to Deepgram for real-time transcription and then discarded.
                </p>
              </div>
            </div>

            <div className="permission-item">
              <span className="permission-icon">🔐</span>
              <div>
                <h3>Privacy</h3>
                <p>Audio is processed in real-time and not stored on our servers.</p>
              </div>
            </div>
          </div>

          <label className="permission-checkbox">
            <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
            <span>
              I understand and agree to the audio processing terms and grant microphone access
            </span>
          </label>
        </div>

        <div className="permission-footer">
          <button type="button" className="btn btn-secondary" onClick={onDecline}>
            Not Now
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAccept}
            disabled={!agreed}
          >
            Start Recording
          </button>
        </div>
      </div>
    </div>
  );
}
